import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import classes from './Zoom.module.scss';

function Zoom({ zoom: Component, onClose }) {
	return (
		<>
			<div className={classes.Close} onClick={onClose}>
				<div className={[classes.Hovicon, classes.Effect].join(' ')}>
					<CloseIcon />
				</div>
			</div>

			<Component />
		</>
	);
}

export default Zoom;
